import ShopifyCart from 'lowcode/common/ShopifyCart';
import EFPicture from '@elem/compCommon/EFPicture';

import J1 from './J1';
import Z2 from './Z2';
import Support from './Support';
import styles from './index.module.scss';
import PowerSupport from './PowerSupport';
import ElectricalAppliances from './ElectricalAppliances';
import OccasionChoose from './OccasionChoose';
import ImgSectionPro from './components/ImgSectionPro';
import EasyUse from './EasyUse';
import Safe from './Safe';
import Important from './Important';
import SocialContributionActivities from './SocialContributionActivities';
import BundleBox from './BundleBox';
import Map from './Map';
import SectionPro from './components/SectionPro';
import Reason from './Reason';

// const Reason = dynamic(() => import('./Reason/index'), { ssr: false });

export default function JP() {
    return (
        <>
            <div className={styles.PowerStation} style={{ overflow: 'hidden' }}>
                <J1 />
                <Z2 />
                {/* <J3 /> */}
                <Support />
                <ElectricalAppliances />
                <PowerSupport />

                <div className="GtmModuleData-section chezhongbo-box" data-section-id="chezhongbo-box" data-section-title="車中泊の電力は移動中にチャージ">
                    <ImgSectionPro
                        className="chezhongbo"
                        label="自動車の走行中に2.6時間でフル充電"
                        title={
                            <p>
                                車中泊の電力は
                                <br />
                                移動中にチャージ
                            </p>
                        }
                        desc="DELTA 2 Maxは、これまでにない急速走行充電を実現するEcoFlow 800W Alternator Chargerに対応しています。従来のシガーソケットに比べて約8倍の急速走行充電ができるため、お出かけ前の充電忘れも心配ありません。自動車の走行中やアイドリング中に発生する余剰電力で充電するため、移動時間で効率的に充電できるだけでなく、お得に充電が可能です。"
                        src="https://websiteoss.ecoflow.com/upload/image/1744956727423/AC%2BD2M%20%E6%89%A9%E5%9B%BE%20(2)%20(1).jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1744957808592/AC%2BD2M%20%E6%89%A9%E5%9B%BE%20(1).png"
                    />
                </div>

                <div className="GtmModuleData-section output-box" data-section-id="output-box" data-section-title="高効率ソーラーパネルでプラスαの安心">
                    <ImgSectionPro
                        label="ニーズに合わせて選べる幅広い出力"
                        title={
                            <div>
                                高効率ソーラーパネルで
                                <br />
                                プラスαの安心
                            </div>
                        }
                        desc="DELTA 2 Maxには、最大500Wのソーラー入力ポートが2つ搭載されているため、EcoFlowの幅広いソーラーパネルと組み合わせることで車中泊も非常時も、より安心して電力を使用・供給することができます。業界トップクラスの電力変換効率や、IP68防水・防塵性能を含む高い耐久性を備えつつ、折りたたみ可能で持ち運びもラクラク。車や自宅の隙間スペースに詰んでおくだけでプラスαの安心を提供します。"
                        src="https://websiteoss.ecoflow.com/upload/image/1744956785015/D2M%2B220Wx4%20(2)%20(1).jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1744957809200/D2M%2B220Wx4%20(3)%20(1).jpg"
                    />
                </div>

                {/* 超值套装 */}
                <OccasionChoose />

                <div
                    className="GtmModuleData-section charging-box"
                    data-section-id="charging-box"
                    data-section-title="複数機器を同時に使えて、車中泊でも自宅のような快適さ"
                >
                    <ImgSectionPro
                        label={
                            <span>
                                充実の15出力ポート、スマホの充電も
                                <br />
                                家電の給電もこれ1台
                            </span>
                        }
                        title={
                            <div className="nowrap">
                                複数機器を同時に使えて、
                                <br />
                                車中泊でも自宅のような快適さ
                            </div>
                        }
                        desc="本体の前面と背面に分けて配置された出力ポートで、ケーブルが絡まずすっきり使える便利な設計。スマホの充電や複数機器への給電を同時にできます。家族や大人数でもポート不足の心配がなく、快適で便利な車中泊ライフはもちろん、車中泊避難に安心をプラスします。"
                        src="https://websiteoss.ecoflow.com/upload/image/1744956840396/20241111ecofrow058419a%202%20(1).jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1744957808825/7.25.2024-ECOFLOW5713%E6%AC%A7%E8%A7%84%20(2).jpg"
                    />
                </div>

                <div
                    className="GtmModuleData-section maintenance-box"
                    data-section-id="maintenance-box"
                    data-section-title="排気ガス / 騒音フリーでメンテナンスも簡単"
                >
                    <ImgSectionPro
                        label="エコで安全・快適な車中泊を"
                        title={
                            <div>
                                排気ガス / 騒音フリーで <br />
                                メンテナンスも簡単
                            </div>
                        }
                        desc="500W未満の出力時に、図書館の環境音と同レベル（30dB）の超静音動作を実現。排気ガスも出ないため、車中泊など狭い空間でも静かで安全な環境を保ち、楽しい会話や快適な睡眠を妨げません。ストレスや不安が大きい災害時には、少しでも快適な空間作りに貢献します。"
                        src="https://websiteoss.ecoflow.com/upload/image/1744956897916/D2M%2B%E7%A9%BA%E8%B0%83%20%E8%BD%A6%E5%86%85%E5%AE%89%E9%9D%99%E8%BF%87%E5%A4%9C%20(1).jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1744957809417/D2M%2B%E7%A9%BA%E8%B0%83%20%E8%BD%A6%E5%86%85%E5%AE%89%E9%9D%99%E8%BF%87%E5%A4%9C%20(2)%20(1).jpg"
                    />
                </div>

                <div className="GtmModuleData-section power-box" data-section-id="power-box" data-section-title="もしもの備えに役立つ 自動電源切り替え機能">
                    <ImgSectionPro
                        label="冷蔵庫やパソコンの停電対策に"
                        title={
                            <div>
                                もしもの備えに役立つ <br /> 自動電源切り替え機能
                            </div>
                        }
                        desc={
                            <div>
                                停電時、20ms未満で接続機器の電源を商用電源から自動的に切り替えて安全に給電*します。冷蔵庫やPCなど、継続的な給電が重要な電化製品を停電から守ります。
                                <div className="explain">
                                    *本機能は、無停電電源装置（UPS）機能ではありません。データサーバーや重要なデータを扱うPCなど、UPSを要する機器には使用しないでください。
                                </div>
                            </div>
                        }
                        src="https://websiteoss.ecoflow.com/upload/image/1744956950947/D2M%20%E5%AE%B6%E5%BA%AD%E9%98%B2%E7%81%BE%20(1).jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1744957809007/D2M%20%E5%AE%B6%E5%BA%AD%E9%98%B2%E7%81%BE%20(1).png"
                    />
                </div>

                <div className="GtmModuleData-section battery-box" data-section-id="battery-box" data-section-title="10年間の長寿命LFPバッテリー採用">
                    <ImgSectionPro
                        label="10年間の長寿命LFPバッテリー採用"
                        title="10年間、大切な人を守り続ける安心のバックアップ"
                        desc="大容量のDELTA 2 Maxは、災害時の電力供給にも活躍。高品質LFPバッテリーにより、約3000サイクル使用しても初期容量の80%を維持する長寿命設計です。1日1回の充放電を続けても、約10年間使用可能です。"
                        src="https://websiteoss.ecoflow.com/upload/image/1744957002876/Delta-2_%E7%94%B5%E6%B1%A0%E5%BF%AB%E5%85%8500%EF%BC%88%E6%89%A9%E5%9B%BE%EF%BC%89%201%20(1).jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1744957808420/7.25.2024-ECOFLOW5713%E6%AC%A7%E8%A7%84%20(1)%20(1).jpg"
                    />
                </div>
                <EasyUse />
                <Safe />
                <SectionPro className="safe-bottom">
                    <EFPicture
                        src="https://websiteoss.ecoflow.com/upload/image/1745811537546/%E8%83%8C%E4%B9%A6%20(1).jpg"
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1745811537546/%E8%83%8C%E4%B9%A6%20(1).jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1745811537711/m%20(1).jpg"
                    />
                </SectionPro>
                <Map />
                <Important />
                <SocialContributionActivities />
                <Reason />
                <BundleBox />
            </div>
            <ShopifyCart />
        </>
    );
}
